<template>
    <sync-loader  :color="color"  v-if="spiner" style="margin-left: 45%; padding-top: 10%; padding-bottom: 5%"></sync-loader>
    <v-card v-else>
        <v-toolbar color="bg-gradient-blue" dark>
            <v-toolbar-title>INSCRIBETE AHORA</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title style="font-size: 2rem"> {{price}}$</v-toolbar-title>
        </v-toolbar>
        <v-list>
            <v-list-group  v-for="module in modules">
                <template v-slot:activator >
                    <v-list-tile style="height: 7rem; padding-top: 25px">
                        <div>
                            <div  style="font-weight: 700; color:#546E7A"><span style="margin-top: 200px;padding-top: 200px">{{module.name}}</span></div>
                        </div>
                    </v-list-tile>
                </template>

                <span v-for="lessons in module.lessons" v-if="lessons.module_id = module.id">
                        <v-layout row wrap class="row"  v-for="resource in lessons.resources" v-if="lessons.id = resource.lessons_id" style="padding: 10px 30px 10px 30px">
                             <v-flex lg11 xs10 sm11>
                                 <v-list-tile-content>
                                    <v-list>{{resource.name}}</v-list>
                                </v-list-tile-content>
                             </v-flex>
                             <v-flex lg1 xs2 sm1>
                                 <v-list-tile-action  v-if="resource.data.free === '0'" @click.prevent="getShowModal()">
                                    <i class="material-icons" style="color: grey; cursor: pointer" >lock</i>
                                 </v-list-tile-action>
                                <v-list-tile-action style="color: #0da5c0; text-align: center" v-else>
                                    <i class="material-icons" v-if="resource.type === 1 && resource.data.free === '1'" @click="showVimeo(resource.data.id_video, showModal = true)" style="cursor: pointer">play_circle_outline</i>
                                </v-list-tile-action>
                             </v-flex>
                        </v-layout>
                    </span>
            </v-list-group>
        </v-list>
        <v-dialog v-model="dialog"
                max-width="400" class="bg-gradient-blue">
            <v-card>
                <v-card-title class="headline">Inscribete ahora para ver este contenido</v-card-title>
                <v-card-text>
                    incribirte es muy fácil, agregalo ahora mismo a tu carrito de compras
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn  color="#1A73E8" dark large
                            @click="addCard(courseId)" v-if="!loader">
                        Agregar al Carrito
                    </v-btn>
                    <v-btn  depressed disabled large v-else>Espere...</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div v-if="showModal" @close="showModal = false">
            <transition name="modal">
                <div class="modal-mask-vimeo-no-login">
                    <div class="modal-wrapper-vimeo-no-login">
                        <div class="modal-container-vimeo-no-login">
                             <vimeo-player ref="player" :video-id="videoID" @ready="onReady" player-width="400"></vimeo-player>
                            <div class="modal-footer-vimeo-no-login">
                                <v-btn style="background-color: orangered; color: white;" flat @click="showModal = false">Cerrar</v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

    </v-card>
</template>
<script>
    import axios from 'axios'
    import {mapState, mapGetters} from 'vuex'
    import SyncLoader from 'vue-spinner/src/PulseLoader.vue'

    import vueVimeoPlayer from 'vue-vimeo-player'
    import toastr from 'toastr'
    export default {
        name: 'courseItemTabNoRegister',
        components: {

            vueVimeoPlayer,
            SyncLoader
        },
        data() {
            return {
                modules:'',
                name:'',
                description:'',
                id:'',
                spiner:false,
                moduleShow:false,
                userCourse:'',
                dialog: false,
                vimeoModal: false,
                price: localStorage.getItem('price'),
                color: '#F4511E',
                videoID: null,
                options: {},
                playerReady: true,
                showModal: false,
                loader: false,
            }
        },
        created() {

            this.getModulesCourse();
            this.getUserCourses();
        },
        computed: {
            ...mapGetters([
                'idCourse',
                'CourseName',
                'descriptionCourse',
                'carShop'
            ]),
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
            courseId() {
                return JSON.parse(localStorage.getItem('courseId'));
            },

        },

        methods: {
            getShowModal:function () {
                this.dialog=true;
            },
            hideModal: function () {
                this.dialog=false;
            },

            addCard:function (id) {
                this.loader = true;
                var url = '/api/v1/addShoppingCar';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    user_id: this.userId.id,
                    course_id: id,

                }).then(response => {

                    if (response.data === 'exist'){
                        toastr.info('Este curso ya se encuentra en seleccionado!');
                        toastr.options = {
                            "closeButton": true,
                            "debug": false,
                            "newestOnTop": false,
                            "progressBar": false,
                            "positionClass": "toast-top-left",
                            "preventDuplicates": false,
                            "onclick": null,
                            "showDuration": "300",
                            "hideDuration": "800",
                            "timeOut": "5000",
                            "extendedTimeOut": "1000",
                            "showEasing": "swing",
                            "hideEasing": "linear",
                            "showMethod": "fadeIn",
                            "hideMethod": "fadeOut"
                        }
                        this.loader = false;
                    }else {
                        this.$store.commit('car', response.data);
                        toastr.success('se agrego su curso al carrito de compras!');
                        toastr.options = {
                            "closeButton": true,
                            "debug": false,
                            "newestOnTop": false,
                            "progressBar": false,
                            "positionClass": "toast-top-left",
                            "preventDuplicates": false,
                            "onclick": null,
                            "showDuration": "300",
                            "hideDuration": "800",
                            "timeOut": "5000",
                            "extendedTimeOut": "1000",
                            "showEasing": "swing",
                            "hideEasing": "linear",
                            "showMethod": "fadeIn",
                            "hideMethod": "fadeOut"
                        }
                        this.loader = false;

                    }
                })
            },

            getModulesCourse:function () {
                var url = '/api/v1/getModulesCourses/' + this.courseId;
                this.spiner = true;
                axios.get(url, axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t')).then(response => {
                    this.modules = response.data;
                    this.spiner = false;
                });
            },
            getUserCourses: function () {
                var url = '/api/v1/getUserInCourses';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    user_id: localStorage.getItem('courseId'),
                    course_id: this.userId.id,

                }).then(response => {
                    this.userCourse = response.data
                })
            },
            showVimeo:function (id) {
                this.videoID = id;

            },

            onReady() {
                this.playerReady = true
            },
            play () {
                this.$refs.player.play()
            },
            stop () {
                this.$refs.player.stop()
            }
        }
    }
</script>
<style>
    @media screen and (max-width: 900px) {
        .marginModal{
            margin-top: 100px;
        }
    }
    .modal-mask-vimeo-no-login {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
    .modal-wrapper-vimeo-no-login {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container-vimeo-no-login {
        width: 450px;
        margin: 0px auto;
        text-align: center;
        padding: 2px 5px;
        background-color: #fff;
        border-radius: 1px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;

    }

    .modal-default-button-vimeo-no-login {
        float: right;
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }
    .modal-enter .modal-container-vimeo-no-login,
    .modal-leave-active .modal-container-vimeo-no-login {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>